import actionTypes from './actionTypes';

const hydrateCurrentReport = (payload) => ({
    type: actionTypes.HYDRATE_CURRENT_REPORT,
    payload,
});

const resetReportSection = (section, value) => ({
    type: actionTypes.RESET_REPORT_SECTION,
    payload: {
        section,
        value,
    },
});

const setDateFrom = (dateFromString) => ({
    type: actionTypes.SET_DATE_FROM,
    payload: {
        dateFromString,
    },
});

const setDateTo = (dateToString) => ({
    type: actionTypes.SET_DATE_TO,
    payload: {
        dateToString,
    },
});

const setGameType = (gameTypeId) => ({
    type: actionTypes.SET_GAME_TYPE,
    payload: {
        gameTypeId,
    },
});

const setIsAggregate = (isAggregateFlag) => ({
    type: actionTypes.SET_IS_AGGREGATE,
    payload: {
        isAggregateFlag,
    },
});

const setIsDateRangeFromSeason = (isDateRangeFromSeasons) => ({
    type: actionTypes.SET_IS_DATE_RANGE_FROM_SEASONS,
    payload: {
        isDateRangeFromSeasons,
    },
});

const setFranchiseId = (franchiseId) => ({
    type: actionTypes.SET_FRANCHISE_ID,
    payload: {
        franchiseId,
    },
});

const setPosition = (positionCode) => ({
    type: actionTypes.SET_POSITION,
    payload: {
        positionCode,
    },
});

const setReportName = (reportName) => ({
    type: actionTypes.SET_REPORT_NAME,
    payload: {
        reportName,
    },
});

const setSeasonFrom = (seasonId) => ({
    type: actionTypes.SET_SEASON_FROM,
    payload: {
        seasonId,
    },
});

const setSeasonTo = (seasonId) => ({
    type: actionTypes.SET_SEASON_TO,
    payload: {
        seasonId,
    },
});

const setTimeFrame = (timeFrame) => ({
    type: actionTypes.SET_REPORT_TIME_FRAME,
    payload: {
        timeFrame,
    },
});

const runReport = () => ({ type: actionTypes.RUN_REPORT });

export default {
    hydrateCurrentReport,
    resetReportSection,
    setDateFrom,
    setDateTo,
    setGameType,
    setIsAggregate,
    setIsDateRangeFromSeason,
    setFranchiseId,
    setPosition,
    setReportName,
    setSeasonFrom,
    setSeasonTo,
    setTimeFrame,
    runReport,
};
